/**
 * Format a Shopify price (in cents) into a string
 * @param {number} cents - The price in cents (e.g., 1999 for $19.99)
 * @param {boolean} showCents - Whether to show cents (true = $19.99, false = $20 rounded up)
 * @param {boolean} showCurrency - Whether to show currency symbol (true = $20, false = 20)
 * @param {boolean} showCurrencyCode - Whether to append currency code (true = "20 AUD")
 * @returns {string} - Formatted price string
 */
function formatShopifyPrice(cents, showCents = true, showCurrency = true, showCurrencyCode = true, currency = "AUD", locale = "en") {
  let dollars = cents / 100;
  currency = Shopify?.currency?.active || Shopify?.currency?.default || window.ShopifyAnalytics?.meta?.currency || "AUD";
  locale = Shopify?.locale || document.documentElement.lang || "en";

  if (!showCents) {
    // round UP to the nearest whole dollar
    dollars = Math.ceil(dollars);
  }

  const options = {
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  };

  if (showCurrency) {
    options.style = "currency";
    options.currency = currency;
    options.currencyDisplay = "symbol";
  }

  const formatter = new Intl.NumberFormat(locale, options);
  let formatted = formatter.format(dollars);

  if (showCurrency && showCurrencyCode) {
    const currencyPart = formatter.formatToParts(dollars).find((part) => part.type === "currency");
    if (currencyPart && currencyPart.value === currency) {
      showCurrencyCode = false;
    }
  }

  if (showCurrencyCode) {
    formatted = `${formatted} ${currency}`;
  }

  return formatted;
}

export { formatShopifyPrice };
